import actions from './actions'

export default function WorkOrderTechnicianMapsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_WORKORDERTECHNICIANMAP:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_WORKORDERTECHNICIANMAP:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_WORKORDERTECHNICIANMAP:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_WORKORDERTECHNICIANMAP:
      return {
        ...state,
        editing: { workOrderTechnicianMapID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_WORKORDERTECHNICIANMAP_RECIEVED ||
      actions.UPDATE_WORKORDERTECHNICIANMAP_RECIEVED ||
      actions.DELETE_WORKORDERTECHNICIANMAP_RECIEVED:
      return {
        ...state,
        editing: { workOrderTechnicianMapID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
